import cn from 'classnames';

import BaconLeekChicken from 'images/bacon-leek-grilled-chicken.png';
import BajaCitrusSalmon from 'images/baja-citrus-salmon.png';
import TempoTrayAdSource from 'images/tempo-intro-ad-1.png';
import TempoChickenPiccata from 'images/tempo-intro-ad-2.png';

const STYLE_VARIANTS = {
  sharapova: {
    rightImage: { src: BaconLeekChicken, alt: 'Bacon Leek Grilled Chicken' },
    leftImage: { src: BajaCitrusSalmon, alt: 'Baja Citrus Salmon' },
    rightClassName:
      'absolute bp1:inset-1/2 bp1:top-28 bp1:translate-x-64 bp3:top-22 -right-10 -top-10 w-36 bp1:-right-6 bp1:w-56',
    leftClassName:
      'absolute bp1:inset-1/2 bp1:top-28 bp1:w-52 bp1:-translate-x-[32rem] bp3:top-22 -left-10 -top-9 w-36 rotate-[-12deg] bp1:rotate-0',
  },
  adSource: {
    rightImage: { src: TempoTrayAdSource, alt: 'Tempo Garlic Sesame Chicken' },
    leftImage: { src: TempoChickenPiccata, alt: 'Tempo Chicken Piccata' },
    rightClassName:
      'absolute -right-6 -top-5 w-24 bp1:inset-1/2 bp1:top-4 bp1:w-52 bp1:translate-x-64 bp3:top-3',
    leftClassName:
      'absolute -left-6 -top-5 w-24 bp1:inset-1/2 bp1:top-4 bp1:w-52 bp1:-translate-x-[32rem] bp3:top-6',
  },
};

const ImageSection = ({ variant = 'adSource' }) => {
  const { rightImage, leftImage, rightClassName, leftClassName } = STYLE_VARIANTS[variant];

  return (
    <>
      <div className="bg-tempo-blue-120 p-0" />
      <div>
        <img className={cn(rightClassName)} src={rightImage.src} alt={rightImage.alt} />
        <img className={cn(leftClassName)} src={leftImage.src} alt={leftImage.alt} />
      </div>
    </>
  );
};

export default ImageSection;
